/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import './catalog-configuration';
import '../../resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "UpdateCatalogConfigurationRequest": {
                        "fields": {
                          "catalogConfiguration": {
                            "type": ".squareup.connect.v2.merchant_catalog.service.CatalogConfiguration",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "UpdateCatalogConfigurationResponse": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "catalogConfiguration": {
                            "type": ".squareup.connect.v2.merchant_catalog.service.CatalogConfiguration",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.UpdateCatalogConfigurationRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.UpdateCatalogConfigurationResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UpdateCatalogConfigurationRequest @ squareup/connect/v2/catalog/interfaces/update-catalog-configuration.proto at 19:1
 */
export const UpdateCatalogConfigurationRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.UpdateCatalogConfigurationRequest');
fixType(UpdateCatalogConfigurationRequest);
Builder.createAndAttachToType(UpdateCatalogConfigurationRequest);
/**
 * SOURCE UpdateCatalogConfigurationResponse @ squareup/connect/v2/catalog/interfaces/update-catalog-configuration.proto at 28:1
 */
export const UpdateCatalogConfigurationResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.UpdateCatalogConfigurationResponse');
fixType(UpdateCatalogConfigurationResponse);
Builder.createAndAttachToType(UpdateCatalogConfigurationResponse);